import React from "react";
import {
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { SearchProvider } from "./context/searchcontext";
import { AuthProvider } from "./context/authcontext";
import { UIProvider } from "./context/uicontext";
import Navbar from "./components/navbar";
import Footer from "./components/footer";
import Home from "./components/home";
import Listings from "./components/listings";
import PGDetail from "./components/pgdetail";
import ThankYou from "./components/thankyou";
// import About from "./components/about";
import About from "./components/aboutNew";
import Contact from "./components/contact";
import OwnerDashboard from "./components/ownerdashboard";
import TenantDashboard from "./components/tenantdashboard";
import TenantFormPage from "./components/TenantFormPage";
import TenantFormPageTushar from "./components/TenantformpageTushar";
import TenantFormPageByBarcodeId from "./components/TenantFormPageByBarcodeId";
import ScrollToTop from "./components/ScrollToTop";
import { isListingSlug } from "./utils/slugutils";
import Blog from "./components/blog";

// ✅ Import page tracking hook
import { usePageTracking } from "./hooks/usePageTracking";
import RentReceipt from "./components/rentReceipt";

const shouldShowFooter = (pathname) =>
  pathname === "/" ||
  pathname === "/listings" ||
  pathname === "/blog" ||
  pathname === "/about" ||
  pathname === "/thank-you" ||
  pathname === "/contact" ||
  isListingSlug(pathname) ||
  pathname.startsWith("/pg/");

const ComingSoon = ({ title }) => (
  <main
    className="page"
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      gap: 12,
    }}
  >
    <h2
      style={{
        fontFamily: "Inter,sans-serif",
        fontSize: 24,
        fontWeight: 700,
        color: "#0D0D0D",
      }}
    >
      {title}
    </h2>
    <p
      style={{ fontFamily: "Inter,sans-serif", color: "#6B7280", fontSize: 15 }}
    >
      This page is coming soon.
    </p>
  </main>
);

// ── Replaces the broken `/pg-*` route ────────────────────────────────────────
// RR v6 only treats `*` as a wildcard after `/`, so `/pg-*` never matched.
// This component is mounted on the `*` catch-all and self-dispatches:
//   • /pg-in-pitampura-pppfr          → <Listings />
//   • /pg-boys-under-5000-in-rohini-… → <Listings />
//   • anything else                   → redirect home
const CatchAll = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/pg-")) {
    return <Listings />;
  }
  return <Navigate to="/" replace />;
};

const SiteLayout = () => {
  const { pathname } = useLocation();

  // ✅ Page tracking activate karein
  usePageTracking();

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/listings" element={<Listings />} />

        {/* Individual PG detail page — must stay above the catch-all */}
        <Route path="/pg/:pgSlug" element={<PGDetail />} />

        {/* Post-booking confirmation page — noindex'd inside ThankYou itself.
            Not added to shouldShowFooter() on purpose, so the footer (and its
            outbound links) don't distract from the confirmation. */}
        <Route path="/thank-you" element={<ThankYou />} />

        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blog" element={<Blog />} />
        <Route
          path="/tenant-dashboard"
          element={<ComingSoon title="Tenant Dashboard" />}
        />
        <Route
          path="/admin-dashboard"
          element={<ComingSoon title="Admin Dashboard" />}
        />

        {/* Handles /pg-… slugs; redirects everything else to / */}
        <Route path="*" element={<CatchAll />} />
      </Routes>
      {shouldShowFooter(pathname) && <Footer />}
    </>
  );
};

function App() {
  return (
    <AuthProvider>
      <UIProvider>
        <SearchProvider>
          <Routes>
            <Route path="/owner-dashboard/*" element={<OwnerDashboard />} />
            <Route path="/tenant-dashboard" element={<TenantDashboard />} />
            <Route path="/tenant-form/:pgId" element={<TenantFormPage />} />
            <Route path="/tenant-form-tushar" element={<TenantFormPageTushar />} />
            <Route path="/rentreceipt" element={<RentReceipt />} />
            <Route path="/tenant-form-page/:BarcodeId" element={<TenantFormPageByBarcodeId />} />
            <Route path="/*" element={<SiteLayout />} />
          </Routes>
        </SearchProvider>
      </UIProvider>
    </AuthProvider>
  );
}

export default App;